module.exports = __webpack_public_path__ + "static/media/home_medical1.301f51d6.jpg";